import React, { useContext, useEffect, useState, useRef, useMemo } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import FamilyModal from './extraModal/FamilyModal'
import CustomSelect from '../../../components/CustomSelect'
import { Textarea } from '../../../components/ModalInputs'
import { useDispatch } from 'react-redux'
import { getFamilyStatuses } from '../../../actions/common'

// Константы вынесены за пределы компонента - не пересоздаются
const socialStatuses = [
  { value: 1, name: 'Полная семья' },
  { value: 2, name: 'Неполная семья' },
  { value: 3, name: 'Многодетная семья' },
  { value: 4, name: 'Многодетная семьяМногодетная семьяМногодетная семьяМногодетная семья' },
  { value: 5, name: 'Семья с одним ребенком' },
  { value: 6, name: 'Семья с двумя детьми' },
  { value: 7, name: 'Семья военнослужащего' },
  { value: 8, name: 'Семья педагога' },
  { value: 9, name: 'Семья медработника' },
  { value: 10, name: 'Приемная семья' },
  { value: 11, name: 'Опекунская семья' },
  { value: 12, name: 'Семья с инвалидом' },
  { value: 13, name: 'Малообеспеченная семья' },
  { value: 14, name: 'Семья беженцев' },
  { value: 15, name: 'Семья мигрантов' },
  { value: 16, name: 'Студенческая семья' },
  { value: 17, name: 'Молодая семья' },
  { value: 18, name: 'Семья пенсионеров' },
  { value: 19, name: 'Семья ветерана' },
  { value: 20, name: 'Семья участника СВО' },
  { value: 21, name: 'Неблагополучная семья' },
  { value: 22, name: 'Семья на учете' },
  { value: 23, name: 'Семья в трудной ситуации' },
  { value: 24, name: 'Семья с детьми-сиротами' },
  { value: 25, name: 'Замещающая семья' },
  { value: 26, name: 'Патронатная семья' },
  { value: 27, name: 'Гостевая семья' },
  { value: 28, name: 'Семья с особым ребенком' },
  { value: 29, name: 'Семья священнослужителя' },
  { value: 30, name: 'Другое' },
]

const familyStatusesList = [
  { value: 1, name: 'Благополучная' },
  { value: 2, name: 'Группа риска' },
]

const materialStatuses = [
  { value: 1, name: 'Высокое' },
  { value: 2, name: 'Среднее' },
  { value: 3, name: 'Низкое' },
]

export default function Family() {

  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion } = useContext(StudentsContext)

  const { values = {}, setFieldValue, setValues } = allForms || {}

  const { family } = studentTabData || {}

  // Ref для отслеживания последних загруженных данных
  const lastSyncedFamilyRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)

  useEffect(() => {
    dispatch(getFamilyStatuses())
  }, [dispatch])

  // Синхронизация формы с данными из API (family - объект)
  useEffect(() => {
    const familyJson = JSON.stringify(family)
    if (!addMode && family && setValues && lastSyncedFamilyRef.current !== familyJson) {
      lastSyncedFamilyRef.current = familyJson
      setValues(prev => ({
        ...prev,
        family: Array.isArray(family) ? [...family] : { ...family }
      }))
      if (updateInitialValues) {
        updateInitialValues('family', family)
      }
    }
  }, [family, addMode, setValues, updateInitialValues])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  // Получаем данные семьи из values
  const familyData = Array.isArray(values.family) ? {} : (values.family || {})
  const members = Array.isArray(values.family) ? values.family : (familyData.members || [])

  // Обработчик изменения полей семьи
  const handleFamilyChange = (e) => {
    const { name, value } = e.target
    if (setFieldValue) {
      setFieldValue(`family.${name}`, value)
    }
  }

  // Сохранение данных члена семьи из модалки
  const handleSaveItem = (itemData) => {
    if (!setFieldValue) return
    if (selectedItem === 'add' || !itemData.id) {
      // Добавление нового члена семьи
      const newItem = {
        ...itemData,
        id: `new_${Date.now()}` // временный id для новых записей
      }
      setFieldValue('family.members', [...members, newItem])
    } else {
      // Редактирование существующего
      const updatedMembers = members.map(item =>
        item.id === itemData.id ? itemData : item
      )
      setFieldValue('family.members', updatedMembers)
    }
    setTimeout(() => allForms.handleSubmit(), 0)
    closeModal()
  }

  // Удаление члена семьи
  const handleDeleteItem = (itemId) => {
    if (!setFieldValue) return
    // Если id не начинается с 'new_', значит запись уже в БД - трекаем удаление
    if (!String(itemId).startsWith('new_')) {
      trackDeletion('family_members', itemId)
    }
    const filteredMembers = members.filter(item => item.id !== itemId)
    setFieldValue('family.members', filteredMembers)
  }

  const renderLi = (item, idx) => {
    const { xp_fm_id, firstname, lastname, patronymic, relationship, legalrepresentative } = item
    return (
      <tr key={xp_fm_id || idx} onClick={openModal(item)} style={{ cursor: 'pointer' }}>
        <td>{[lastname, firstname, patronymic].filter(Boolean).join(' ')}</td>
        <td>{relationship || ''}</td>
        <td style={{ textAlign: 'center' }}>{legalrepresentative ? 'Да' : 'Нет'}</td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem &&
        <FamilyModal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          height={'430px'}
          addMode={selectedItem === 'add'}
          onSave={handleSaveItem}
          onDelete={handleDeleteItem}
        />
      }
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Социальный статус семьи'
            valuesName="family.socStatus"
            options={socialStatuses}
            value={familyData.socStatus}
            setFieldValue={setFieldValue}
            width={200}
            withoutAll
            highlight
          />
          <CustomSelect
            title='Статус семьи'
            valuesName="family.familyStatus"
            options={familyStatusesList}
            value={familyData.familyStatus}
            setFieldValue={setFieldValue}
            width={180}
            withoutAll
            searchable={false}
            highlight
          />
          <CustomSelect
            title='Материальное положение семьи'
            valuesName="family.materialStatus"
            options={materialStatuses}
            value={familyData.materialStatus}
            setFieldValue={setFieldValue}
            width={200}
            withoutAll
            searchable={false}
            highlight
          />
        </div>
        <Table className={styles.table} wrapperStyle={{ marginTop: '1rem' }}>
          <thead>
            <tr>
              <th>Фамилия И.О.</th>
              <th>Тип родства</th>
              <th>Законный представитель</th>
            </tr>
          </thead>
          <tbody>
            {members.map((item, idx) => renderLi(item, idx))}
          </tbody>
        </Table>
        <br />
        <Button onClick={openModal('add')}>Добавить</Button>
      </div>

      <div className={styles.qualificationForm}>
        <Textarea
          className={styles.noticeTextarea}
          label='ФИО опекуна'
          name='fiotutor'
          value={familyData.fiotutor || ''}
          onChange={handleFamilyChange}
          style={{ width: '600px', marginTop: '10px' }}
        />
        <Textarea
          className={styles.noticeTextarea}
          label='Награды родителей'
          name='awards'
          value={familyData.awards || ''}
          onChange={handleFamilyChange}
          style={{ width: '600px', marginTop: '10px' }}
        />
        <Textarea
          className={styles.noticeTextarea}
          label='Награды родителей(посмертно)'
          name='awards_death'
          value={familyData.awards_death || ''}
          onChange={handleFamilyChange}
          style={{ width: '600px', marginTop: '10px' }}
        />
        <Textarea
          className={styles.noticeTextarea}
          label='Инвалиды'
          name='invalids'
          value={familyData.invalids || ''}
          onChange={handleFamilyChange}
          style={{ width: '600px', marginTop: '10px' }}
        />
      </div>
    </div>
  )
}
